import React from 'react';
import { cn } from '@/lib/utils';

interface ColorGridPickerProps {
  value: string;
  onChange: (color: string) => void;
}

export const defaultColors = [
  // Main palette (9 rows x 8 columns)
  // Row 3: Mid tones
  '#90CAF9', '#B39DDB', '#F48FB1', '#FFCC80', '#FFF59D', '#C5E1A5', '#A5D6A7', '#80DEEA',
  // Row 4: More saturated
  '#64B5F6', '#9575CD', '#EF5350', '#FFB74D', '#FFF176', '#AED581', '#81C784', '#4DD0E1',
  // Row 5: Even more saturated
  '#42A5F5', '#7E57C2', '#E53935', '#FFA726', '#FFEE58', '#9CCC65', '#66BB6A', '#26C6DA',
  // Row 6: Darker shades, more intense
  '#2196F3', '#673AB7', '#D32F2F', '#FF9800', '#FFEB3B', '#8BC34A', '#4CAF50', '#00BCD4',
  // Row 7: Dark
  '#1976D2', '#512DA8', '#C62828', '#FB8C00', '#FDD835', '#7CB342', '#43A047', '#00ACC1',
  // Row 8: Very Dark
  '#1565C0', '#4527A0', '#B71C1C', '#F57C00', '#FBC02D', '#689F38', '#388E3C', '#0097A7',
  // Row 9: Almost Black
  '#0D47A1', '#311B92', '#8B0000', '#E65100', '#F9A825', '#558B2F', '#2E7D32', '#00838F',
];

const ColorGridPicker: React.FC<ColorGridPickerProps> = ({ value, onChange }) => {
  return (
    <div className="grid grid-cols-8 gap-x-0.5 gap-y-0.5 p-2 border border-input rounded-md bg-background">
      {defaultColors.map((color, index) => (
        <div
          key={index}
          className={cn(
            "w-9 h-9 rounded-sm cursor-pointer border border-gray-200 dark:border-gray-700",
            { 'ring-2 ring-offset-2 ring-primary': value === color.toLowerCase() }
          )}
          style={{ backgroundColor: color }}
          onClick={() => onChange(color)}
        />
      ))}
    </div>
  );
};

export default ColorGridPicker; 